import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { recordInterestFromPathname } from '../utils/featuredPersonalization';

/** Records game interest from URL (e.g. /fortnite/accounts) for home featured personalization. */
export default function BrowseInterestTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    recordInterestFromPathname(pathname);
  }, [pathname]);

  return null;
}
